export default function SectionTitle({ badge, title, desc, right }) {
  return (
    <div className="section-head">
      <div className="left">
        {badge ? <div className="badge">{badge}</div> : null}
        <h2 className="h2">{title}</h2>
        {desc ? <p className="p">{desc}</p> : null}
      </div>
      <div className="right">{right}</div>
    </div>
  );
}
